
Drupal.behaviors.popupEmployees = {

  attach(context) {
    
    // kontrola aby se dialog zavolal pouze jednou - 1. podminka je pro prihlasene, 2. pro neprihlasene
    if (context !== $('dialog.dialog_employees').get(0) && context !== document) {
      return;
    }
    
    const popupEmployees = new window.upceModal('employees');

    if (popupEmployees.status()) {

        // pri otevreni popupu - nastavime cestu pro prihlaseni
        popupEmployees.dialog.addEventListener("open", function(e) {
          const login_field = document.getElementById('employees_login');          
          const { origin, pathname } = window.location;
          const employees_login_url = origin + '/caslogin?destination=' + pathname;
          login_field.setAttribute('href', employees_login_url);          
        });
      
      // console.log("popup SB - employees");

    }
  },
};
